<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/avignonesi')">Avignonesi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri')">Azienda
                        Agricola Casanova di Neri
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-salvioni')">Azienda Salvioni
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/castiglione-del-bosco')">Castiglione del Bosco
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/conti-constani')">Conti Constani
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-le-pupille')">Fattoria Le Pupille
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-poggio-di-sotto')">Fattoria Poggio di
                        Sotto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fontodi')">Fontodi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/frescobaldi')">Frescobaldi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/tuscany/gianfranco-soldera')">Gianfranco Soldera
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/isole-e-olena')">Isole e Olena
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/marchesi-antinori')">Marchesi Antinori
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/podere-poggio-scalette')">Podere Poggio
                        Scalette
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/poderi-boscarelli')">Poderi Boscarelli
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/rocca-di-frassinello')">Rocca di Frassinello
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-dell-ornellaia')">Tenuta dell’Ornellaia
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-di-trinoro')">Tenuta di Trinoro
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-san-guido')">Tenuta San Guido
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Gianfranco Soldera</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        I viticoltori costosi sono sempre stati noti per essere controversi, ma se mai c'è stato un viticoltore che sapeva cosa voleva era Gianfranco Soldera. Famoso per aver bevuto sempre e solo
                        i propri vini, per portare il proprio bicchiere ovunque andasse e consegnare anche il proprio
                        ingredienti nei ristoranti in cui aveva intenzione di mangiare, Soldera non passava inosservato. Quando lui
                        scomparso nel 2019, il mondo del vino ha perso una delle sue figure più imponenti.
                    </div>

                    <div class="howto-title2">Una profezia fatta da sé</div>
                    <div class="howto-text">
                        Meticoloso, lungimirante e un po' mitico, Gianfranco Soldera è stato uno dei più
                        produttori imponenti. Ha stabilito la sua tenuta nel 1972 a Tavernelle, a sud-ovest di Montalcino.
                        Sebbene al momento dell'acquisto della proprietà non crescessero viti, Soldera era incrollabile
                        convinzione che i dolci pendii esposti a sud sarebbero perfetti per la produzione commerciale. Come sempre,
                        ha dato ragione, grazie al microclima secco, alle lunghe ore di sole e alla ricchezza di minerali
                        suolo. Un paladino dell'agricoltura biologica prima ancora che diventasse di moda, Soldera e sua moglie
                        piantato un'utopia bucolica in cui le viti potessero prosperare, completa di 1.500 varietà di rose,
                        ulivi, un lago artificiale e nidi di uccelli artificiali per fornire la casa perfetta per a
                        moltitudine di insetti (non pericolosi per la vite). Per quanto controversa possa essere stata la sua personalità, ecco
                        Non c'è dubbio che i suoi vini cantino con un'eloquenza e una poesia atipiche persino per il Chianti.
                    </div>

                    <div class="howto-title2">Il peggior crimine legato al vino al mondo</div>
                    <div class="howto-text">
                        Ma come con molte personalità polarizzanti, è riuscito a infastidire più di una persona e nel 2012
                        un ex impiegato scontento ha aperto i rubinetti dei tini di affinamento delle annate 2007-2012,
                        gettando nello scarico oltre 62.000 litri di vino. Il colpevole ora sta scontando la pena
                        sabotaggio, ma fino ad oggi rimane uno dei crimini più dispettosi della vinificazione.
                    </div>

                    <div class="howto-title2">Su 10 posti nella lista dei vini più costosi d'Italia</div>
                    <div class="howto-text">
                        La convinzione di Soldera che l'Europa e gli Stati Uniti siano "finiti" significa che oggi è il suo più grande export
                        mercato è l'Asia (anche se questo cambierà sotto la nuova gestione dei vigneti non lo sappiamo
                        Sapere). Molto apprezzati i suoi vini longevi e il suo Case Basse Brunello di Montalcino
                        Riserva è il secondo vino più costoso d'Italia (il primo è il Masseto della Tenuta dell'Ornellaia).
                        Questo da solo dimostra il valore del suo vino, dato che una classifica del 2012 lo ha collocato al 12° posto.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Gianfranco Soldera</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Es war schon immer bekannt, dass teure Winzer umstritten sind, aber wenn es jemals einen Winzer gab, der wusste, was er wollte, dann war es Gianfranco Soldera. Berühmt dafür, dass er immer nur trinkt
                        seine eigenen Weine, dafür, dass er sein eigenes Glas überall hin mitnahm und sogar sein eigenes auslieferte
                        Als er Zutaten in alle Restaurants brachte, in denen er essen wollte, blieb Soldera nicht unbemerkt. Als er
                        Mit dem Tod im Jahr 2019 verlor die Weinwelt eine ihrer imposantesten Persönlichkeiten.
                    </div>

                    <div class="howto-title2">Eine selbst gemachte Prophezeiung</div>
                    <div class="howto-text">
                        Akribie, Weitblick und eine Art Legende: Gianfranco Soldera war einer der größten Meister Montalcinos
                        imposante Produzenten. Er gründete sein Weingut 1972 in Tavernelle, südwestlich von Montalcino.
                        Obwohl zum Zeitpunkt des Kaufs des Grundstücks keine Weinreben wuchsen, blieb Soldera standhaft
                        Ich war davon überzeugt, dass die sanften, nach Süden ausgerichteten Hänge perfekt für die kommerzielle Produktion geeignet wären. Wie immer,
                        Dank des trockenen Mikroklimas, der langen Sonnenstunden und des Mineralienreichtums hat er Recht behalten
                        Boden. Soldera und seine Frau waren Verfechter des ökologischen Landbaus, lange bevor er in Mode kam
                        pflanzte eine idyllische Utopie, in der die Reben gedeihen konnten, komplett mit 1.500 Rosensorten,
                        Olivenbäume, ein künstlicher See und künstliche Vogelnester bieten das perfekte Zuhause für einen
                        Vielzahl (nicht rebenbedrohender) Insekten. So umstritten seine Persönlichkeit auch gewesen sein mag
                        Es besteht kein Zweifel daran, dass seine Weine von einer Beredsamkeit und Poesie singen, die selbst für Chianti untypisch ist.
                    </div>

                    <div class="howto-title2">Das schlimmste Weinverbrechen der Welt</div>
                    <div class="howto-text">
                        Aber wie viele polarisierende Persönlichkeiten gelang es ihm, mehr als eine Person zu verärgern, und zwar im Jahr 2012
                        Ein verärgerter ehemaliger Angestellter öffnete die Hähne an den Reifefässern der Jahrgänge 2007-2012.
                        über 62.000 Liter Wein in den Abfluss fließen lassen. Der Täter sitzt nun im Gefängnis
                        Sabotage, aber bis heute ist sie eines der gehässigsten Verbrechen in der Weinherstellung.
                    </div>

                    <div class="howto-title2">Um 10 Plätze auf der teuersten Weinkarte Italiens</div>
                    <div class="howto-text">
                        Solderas Überzeugung, dass Europa und die USA „vorbei“ sind, bedeutet heute seinen größten Export
                        Der Markt ist Asien (ob sich dies unter der neuen Führung der Weinberge ändern wird, wissen wir jedoch nicht
                        wissen). Seine langlebigen Weine sind hochgelobt und sein Case Basse Brunello di Montalcino
                        Riserva ist Italiens zweitteuerster Wein (der erste ist der Masseto von Tenuta dell'Ornellaia).
                        Dies allein beweist den Wert seines Weins, denn eine Tabelle aus dem Jahr 2012 brachte ihn auf den 12. Platz.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Gianfranco Soldera</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Les vignerons chers ont toujours été connus pour être controversés, mais s'il y a jamais eu un viticulteur qui savait ce qu'il voulait, c'était bien Gianfranco Soldera. Célèbre pour n'avoir jamais bu
                        ses propres vins, pour transporter son propre verre partout où il allait et même livrer le sien
                        ingrédients dans tous les restaurants où il prévoyait de manger, Soldera n'est pas passé inaperçu. Quand il
                        décédé en 2019, le monde du vin a perdu l'une de ses figures les plus imposantes.
                    </div>

                    <div class="howto-title2">Une prophétie autodidacte</div>
                    <div class="howto-text">
                        Méticuleux, clairvoyant et un peu légendaire, Gianfranco Soldera était l'un des plus grands
                        producteurs imposants. Il a établi son domaine en 1972 à Tavernelle, au sud-ouest de Montalcino.
                        Bien qu'aucune vigne ne pousse au moment de l'achat de la propriété, Soldera avait l'indéfectible
                        croire que les pentes douces et orientées au sud seraient parfaites pour la production commerciale. Comme toujours,
                        il a donné raison, grâce au microclimat sec, aux longues heures d'ensoleillement et à la richesse minérale
                        sol. Champion de l'agriculture biologique bien avant qu'elle ne devienne à la mode, Soldera et sa femme
                        planté une utopie bucolique où s'épanouir la vigne, agrémentée de 1 500 variétés de rosiers,
                        des oliviers, un lac artificiel et des nids d'oiseaux artificiels pour fournir la maison parfaite pour un
                        multitude d'insectes (qui ne menacent pas la vigne). Aussi controversé que sa personnalité ait pu être, il
                        ne fait aucun doute que ses vins chantent avec une éloquence et une poésie atypique même pour le Chianti.
                    </div>

                    <div class="howto-title2">Le pire crime lié au vin au monde</div>
                    <div class="howto-text">
                        Mais comme beaucoup de personnalités polarisantes, il a réussi à en agacer plus d'un et en 2012
                        un ancien employé mécontent a ouvert les robinets des cuves d'élevage des millésimes 2007-2012,
                        laissant plus de 62 000 litres de vin se déverser dans les égouts. Le coupable purge maintenant sa peine
                        sabotage mais à ce jour, il reste l'un des crimes les plus méchants de la viticulture.
                    </div>

                    <div class="howto-title2">Gagnez 10 places dans la carte des vins la plus chère d'Italie</div>
                    <div class="howto-text">
                        La conviction de Soldera que l'Europe et les États-Unis sont "terminés" signifie qu'aujourd'hui sa plus grande exportation
                        marché est l'Asie (bien que cela changera sous la nouvelle gestion des vignobles, nous ne le savons pas
                        savoir). Ses vins de longue garde sont très appréciés et sa Case Basse Brunello di Montalcino
                        Riserva est le deuxième vin le plus cher d'Italie (le premier est le Masseto de Tenuta dell'Ornellaia).
                        Cela prouve à lui seul la valeur de son vin, puisqu'une table de 2012 l'a placé à la 12e place.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Gianfranco Soldera</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Expensive winemakers have always been known to be controversial, but if ever there was a viticulturist who knew what he wanted it was Gianfranco Soldera. Famous for only ever drinking
                        his own wines, for carrying his own glass wherever he went and even delivering his own
                        ingredients to any restaurants where he planned to eat, Soldera did not go unnoticed. When he
                        died in 2019, the wine world lost one of its most imposing figures.
                    </div>

                    <div class="howto-title2">A self-made prophecy</div>
                    <div class="howto-text">
                        Meticulous, far-sighted and a bit of a legend, Gianfranco Soldera was one of Montalcino's most
                        imposing producers. He established his estate in 1972 in Tavernelle, southwest of Montalcino.
                        Although no vines were growing when the property was purchased, Soldera had the unwavering
                        belief that the gentle, south-facing slops would be perfect for commercial production. As ever,
                        he proved himself right, thanks to the dry microclimate, long hours of sunlight and mineral-rich
                        soil. A champion of organic farming long before it became fashionable, Soldera and his wife
                        planted a bucolic utopia in which the vines could thrive, complete with 1,500 rose varieties,
                        olive trees, an artificial lake and man-made birds’ nests to provide the perfect home for a
                        multitude (non-vine threatening) insects. As contentious as his personality may have been, there
                        is no doubt that his wines sing with eloquence and poetry that is atypical even for Chianti.
                    </div>

                    <div class="howto-title2">The world’s worst wine crime</div>
                    <div class="howto-text">
                        But as with many polarising personalities, he managed to annoy more than one person and in 2012
                        a disgruntled former employed opened the taps on the ageing vats of the vintages from 2007-2012,
                        letting over 62,000 litres of wine pour down the drain. The culprit is now doing time for
                        sabotage but to this day, it remains one of winemaking’s most spiteful crimes.
                    </div>

                    <div class="howto-title2">Up 10 places in Italy’s most expensive wine list</div>
                    <div class="howto-text">
                        Soldera’s conviction that Europe and the US are “over” means that today his largest export
                        market is Asia (although whether this will change under the vineyards new stewardship we don’t
                        know). His long-lived wines are highly acclaimed and his Case Basse Brunello di Montalcino
                        Riserva is Italy's second most expensive wine (the first is Tenuta dell'Ornellaia’s Masseto).
                        This alone proves the worth of his wine, as a 2012 table set him in 12th place.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "GianfrancoSoldera",
    head: {
        title: 'Gianfranco Soldera | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional quality of wines produced by Gianfranco Soldera, a renowned wine producer in Tuscany, Italy. Savor the unique blend of tradition and innovation in every bottle, crafted with passion and care in the heart of the Tuscan countryside. Experience the epitome of Tuscany wine with Gianfranco Soldera.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Gianfranco Soldera', src: '/wine-guide/italy/tuscany/gianfranco-soldera'},
            items: [
                {report: 'Avignonesi', src: '/wine-guide/italy/tuscany/аvignonesi'},
                {
                    report: 'Azienda Agricola Casanova di Neri',
                    src: '/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri'
                },
                {report: 'Azienda Salvioni', src: '/wine-guide/italy/tuscany/azienda-salvioni'},
                {report: 'Castiglione del Bosco', src: '/wine-guide/italy/tuscany/castiglione-del-bosco'},
                {report: 'Conti Constani', src: '/wine-guide/italy/tuscany/conti-constani'},
                {report: 'Fattoria Le Pupille', src: '/wine-guide/italy/tuscany/fattoria-le-pupille'},
                {report: 'Fattoria Poggio di Sotto', src: '/wine-guide/italy/tuscany/fattoria-poggio-di-sotto'},
                {report: 'Fontodi', src: '/wine-guide/italy/tuscany/fontodi'},
                {report: 'Frescobaldi', src: '/wine-guide/italy/tuscany/frescobaldi'},
                {report: 'Gianfranco Soldera', src: '/wine-guide/italy/tuscany/gianfranco-soldera'},
                {report: 'Isole e Olena', src: '/wine-guide/italy/tuscany/isole-e-olena'},
                {report: 'Marchesi Antinori', src: '/wine-guide/italy/tuscany/marchesi-antinori'},
                {report: 'Podere Poggio Scalette', src: '/wine-guide/italy/tuscany/podere-poggio-scalette'},
                {report: 'Poderi Boscarelli', src: '/wine-guide/italy/tuscany/poderi-boscarelli'},
                {report: 'Tenuta dell’Ornellaia', src: '/wine-guide/italy/tuscany/tenuta-dell-ornellaia'},
                {report: 'Tenuta di Trinoro', src: '/wine-guide/italy/tuscany/tenuta-di-trinoro'},
                {report: 'Tenuta San Guido', src: '/wine-guide/italy/tuscany/tenuta-san-guido'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}
.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
